import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FinanceService } from '../shared/finance.service';
import { AngularFireDatabase } from 'angularfire2/database';
import 'rxjs/add/operator/toPromise';
import { IOption } from 'ng-select';
import { PageChangeEvent } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-finance-settings',
  templateUrl: './finance-settings.component.html',
  styleUrls: ['./finance-settings.component.scss']
})
export class FinanceSettingsComponent implements OnInit {
  myForm: FormGroup;
  catTypeForm: FormGroup;
  vatForm: FormGroup;
  accTypeForm: FormGroup;
  submitted: boolean = false;
  @ViewChild('AddFinanceExpCategory') FinanceExpCategoryModal;
  @ViewChild('AddFinanceExpCategoryType') AddFinanceExpCategoryType;
  @ViewChild('AddFinanceAccountType') AddFinanceAccountType;
  @ViewChild('deleteModal') deleteModal;

  id: any;
  isEdit = false;
  doesExist = false;
  dependencyExist = false;
  exists: any;
  from: string;
  existsMessage: any;
  dependencyMessage: any;
  name: string;
  currentVat = 0;
  public skip = 0;
  public skip1 = 0;
  public skip2 = 0;
  public pageSize = 10;
  FinanceAccountType:any;
  OriginalFinanceAccountType:any;
  lastId = 201900000001;
  constructor(private financeService: FinanceService, private db: AngularFireDatabase) { }

  ngOnInit() {
    this.initilaizeForm();
    this.getAllFinanceExpenseCat();
    this.getAllFinanceExpenseCatType();
    this.getCategoryType();
    this.getVat();
    this.getAccountKey();
    //this.getAllFinanceAccountType();
  }

  FinanceExpenseCat:any;
  OriginalFinanceExpenseCat:any;
  FinanceExpenseCatType:any;
  OriginalFinanceExpenseCatType:any;
  ProfLoss: Array<IOption> = [
    { label: 'Credit', value: 'Profit' },
    { label: 'Debit', value: 'Loss' }
  ];

  accType: Array<IOption> = [
    { label: 'Individual', value: 'Individual' },
    { label: 'Group', value: 'Group' }
  ];
  categoryTypeList: Array<IOption> = [];
  vatList = [];

  private initilaizeForm() {
    this.myForm = new FormGroup({
      categoryName: new FormControl('', Validators.required),
      categoryType: new FormControl('', Validators.required),
      amount: new FormControl('', Validators.required),
      categoryDescription: new FormControl('', Validators.required),
      id: new FormControl()
    });

    this.catTypeForm = new FormGroup({
      typeName: new FormControl('', Validators.required),
      typeProfLoss: new FormControl('', Validators.required),
      id: new FormControl()
    });

    this.vatForm = new FormGroup({
      vatAmount: new FormControl('', [Validators.required, Validators.pattern('[0-9]*[\.]?[0-9]{1,2}')]),
      id: new FormControl()
    });

    this.accTypeForm = new FormGroup({
      accTypeName: new FormControl('', Validators.required),
      accTypeLevel: new FormControl('', Validators.required),
      accTypeDesc: new FormControl('', Validators.required),
      id: new FormControl()
    });
  }

  getAccountKey() {
    const d = this.db.list('/financeExpenseCat', ref => ref.orderByKey().limitToLast(1)).valueChanges();
    d.subscribe(data => {
      data.forEach(d => {
        var year = (String(d["id"])).substring(0, 4);
        var date = new Date();
        var currentYear = date.getFullYear();
        if (year == String(currentYear)) {
          this.lastId = parseInt(d["id"]) + 1;
        } else {
          this.lastId = parseInt(currentYear + "00000000");
        }
      });
    });
  }


  checkExistsWhileAdd(name, field, from) {
    let promise = new Promise((resolve, reject) => {
      return this.financeService.find(name, field, from).once("value").then(res => { // Success
        resolve([res.numChildren(),res]);
      });
    });
    return promise;
  }
  showExitsMessage(name, from) {
    this.existsMessage = name + ' already exists in ' + from;
    this.doesExist = true;
  }

  checkDependency(dependentdb, dependentColumnName, dependentValue) {
    let promise = new Promise((resolve, reject) => {
      return this.financeService.checkDependency(dependentdb, dependentColumnName, dependentValue).once("value").then(res => { // Success
        resolve(res.numChildren());
      });
    });
    return promise;
  }

  showDependencyMessage(count, dependentModule, moduleName) {
    this.dependencyMessage = 'Delete Failed !! This ' + moduleName + ' has ' + count + ' dependencies in ' + dependentModule;
    this.dependencyExist = true;
  }

  onSubmit() {
    var self = this;
    this.doesExist = false;
    this.submitted = true;
    if (this.myForm.valid) {
      this.checkExistsWhileAdd(this.myForm.value.categoryName, 'categoryName', 'financeExpenseCat').then((data) => {
        if(data[0]!==0) {
          var res = data[1].val();
          var key = Object.keys(res);
        }
        if (data[0] == 0 || (key[0]===this.myForm.value.id && data[0]==1 && this.isEdit)) {
          if (!this.isEdit) {
            this.myForm.controls['id'].setValue(self.lastId);
            this.financeService.addfinanceExpenseCat(this.myForm.value,this.lastId).then(() => {
              this.submitted = false;
              this.myForm.reset();
              this.FinanceExpCategoryModal.hide();
            });
          }
          else {
            this.financeService.updateFinanceExpenseCat(this.myForm.value).then(() => {
              this.submitted = false;
              this.isEdit = false;
              this.myForm.reset();
              this.FinanceExpCategoryModal.hide();
            });
          }
        } else {
          this.showExitsMessage(this.myForm.value.categoryName, 'Category Name');
        }
      });
    }
  }

  getAllFinanceExpenseCat() {
    var x = this.financeService.getAllFinanceExpenseCat();
    x.snapshotChanges().subscribe(item => {
      this.FinanceExpenseCat = [];
      this.OriginalFinanceExpenseCat = [];
      item.forEach(element => {
        this.FinanceExpenseCat.push({
          "CategoryName": String(element.payload.child("categoryName").val()),
          "CategoryType": String(element.payload.child("categoryType").val()),
          "Amount": String(element.payload.child("amount").val()),
          "Description": String(element.payload.child("categoryDescription").val()),
          "id": element.key
        });
        this.OriginalFinanceExpenseCat.push({
          "CategoryName": String(element.payload.child("categoryName").val()),
          "CategoryType": String(element.payload.child("categoryType").val()),
          "Amount": String(element.payload.child("amount").val()),
          "Description": String(element.payload.child("categoryDescription").val()),
          "id": element.key
        });
      });
      this.loadItemSearchResult('FinanceExpenseCat');
    });
  }

  editFinanceExpenseCat(id) {
    this.isEdit = true;
    this.id = id;
    var x = this.financeService.getFinanceExpenseCat(id);
    x.once("value").then((FinanceExpenseCat) => {
      this.myForm.get('categoryName').setValue(FinanceExpenseCat.child("categoryName").val(), Validators.required);
      this.myForm.get('categoryType').setValue(FinanceExpenseCat.child("categoryType").val(), Validators.required);
      this.myForm.get('amount').setValue(FinanceExpenseCat.child("amount").val(), Validators.required);
      this.myForm.get('categoryDescription').setValue(FinanceExpenseCat.child("categoryDescription").val(), Validators.required);
      this.myForm.get('id').setValue(id);
    });

    this.FinanceExpCategoryModal.show();
  }


  // Category Type

  getCategoryType() {
    var y: any;
    var catType = this.db.list("financeExpenseCatType");
    catType.snapshotChanges().subscribe(item => {
      this.categoryTypeList = [];
      item.forEach(element => {
        y = element.payload.toJSON();
        this.categoryTypeList.push({ label: String(y.typeName), value: String(y.typeName) });
      });
    });
  }

  getAllFinanceExpenseCatType() {
    var x = this.financeService.getAllFinanceExpenseCatType();
    x.snapshotChanges().subscribe(item => {
      this.FinanceExpenseCatType = [];
      this.OriginalFinanceExpenseCatType = [];
      item.forEach(element => {
        this.FinanceExpenseCatType.push({
          "typeName": String(element.payload.child("typeName").val()),
          "typeProfLoss": String(element.payload.child("typeProfLoss").val()),
          "id": element.key
        });

        this.OriginalFinanceExpenseCatType.push({
          "typeName": String(element.payload.child("typeName").val()),
          "typeProfLoss": String(element.payload.child("typeProfLoss").val()),
          "id": element.key
        });
      });
      this.loadItemSearchResult('FinanceExpenseCatType');
    });
  }

  submitCatType() {
    this.submitted = true;
    this.doesExist = false;
    if (this.catTypeForm.valid) {
      this.checkExistsWhileAdd(this.catTypeForm.value.typeName, 'typeName', 'financeExpenseCatType').then((data) => {
        if(data[0]!==0) {
          var res = data[1].val();
          var key = Object.keys(res);
        }
        if (data[0] == 0 || (key[0]===this.catTypeForm.value.id && data[0]==1 && this.isEdit)) {
          if (!this.isEdit) {
            this.financeService.addfinanceExpenseCatType(this.catTypeForm.value).then(() => {
              this.submitted = false;
              this.catTypeForm.reset();
              this.AddFinanceExpCategoryType.hide();
            });
          }
          else {
            this.financeService.updateFinanceExpenseCatType(this.catTypeForm.value).then(() => {
              this.submitted = false;
              this.isEdit = false;
              this.catTypeForm.reset();
              this.AddFinanceExpCategoryType.hide();
            });
          }
        }
        else {
          this.showExitsMessage(this.catTypeForm.value.typeName, 'Category Type');
        }
      });
    }
  }

  editFinanceExpenseCatType(id) {
    this.isEdit = true;
    this.id = id;
    var x = this.financeService.getFinanceExpenseCatType(id);
    x.once("value").then((FinanceExpenseCatType) => {
      this.catTypeForm.get('typeName').setValue(FinanceExpenseCatType.child("typeName").val(), Validators.required);
      this.catTypeForm.get('typeProfLoss').setValue(FinanceExpenseCatType.child("typeProfLoss").val(), Validators.required);
      this.catTypeForm.get('id').setValue(id);
    });

    this.AddFinanceExpCategoryType.show();
  }

  public openDeleteModal(id, name, from): void {
    this.dependencyExist = false;
    this.id = id;
    this.from = from;
    this.name = name;
    this.deleteModal.show();
  }
  public delete(): void {
    switch (this.from) {
      case 'Category':
        this.checkDependency('financeTransactions', 'categoryName', this.name).then((data) => {
          if (data == 0) {
            this.financeService.deleteCat(this.id).then(() => {
              this.id = null;
              this.from = null;
              this.deleteModal.hide();
            });
          } else {
            this.showDependencyMessage(data, 'Transactions', 'Category');
          }
        });
        break;

      case 'Category Type':
        this.checkDependency('financeExpenseCat', 'categoryType', this.name).then((data) => {
          if (data == 0) {
            this.financeService.deleteCatType(this.id).then(() => {
              this.id = null;
              this.from = null;
              this.deleteModal.hide();
            });
          } else {
            this.showDependencyMessage(data, 'Category', 'Category Type');
          }
        });
        break;

      case 'Account Type':
        this.checkDependency('financeAccounts','accType',this.name).then((data)=> {
        if(data==0) {
        this.financeService.deleteFinanceAccountType(this.id).then(() => {
          this.id = null;
          this.from = null;
          this.deleteModal.hide();
        });
        } else {
        this.showDependencyMessage(data,'Finance Accounts','Account Type');
         }
        });
        break;
    }
  }

  //Finance VAT
  getVat() {
    var x = this.financeService.getVat();
    this.vatList = [];
    x.snapshotChanges().subscribe(item => {
      item.forEach(element => {
        this.vatForm.get('vatAmount').setValue(element.payload.child("vatAmount").val(), Validators.required);
        this.vatForm.get('id').setValue(element.key);
        this.currentVat = element.payload.child("vatAmount").val();
      });
    });
  }

  onSubmitVat() {
    this.submitted = true;
    if (this.vatForm.valid) {
      this.vatForm.get('id').setValue('vatValueId');
      this.financeService.submitVat(this.vatForm.value).then(() => {
        this.submitted = false;
      });
    }
  }

  //Finance Account Type
  getAllFinanceAccountType() {
    var x = this.financeService.getAllFinanceAccountType();
    x.snapshotChanges().subscribe(item => {
      this.FinanceAccountType = [];
      this.OriginalFinanceAccountType = [];
      item.forEach(element => {
        this.FinanceAccountType.push({
          "accTypeName": String(element.payload.child("accTypeName").val()),
          "accTypeLevel": String(element.payload.child("accTypeLevel").val()),
          "accTypeDesc": String(element.payload.child("accTypeDesc").val()),
          "id": element.key
        });

        this.OriginalFinanceAccountType.push({
          "accTypeName": String(element.payload.child("accTypeName").val()),
          "accTypeLevel": String(element.payload.child("accTypeLevel").val()),
          "accTypeDesc": String(element.payload.child("accTypeDesc").val()),
          "id": element.key
        });
      });
      this.loadItemSearchResult('FinanceAccountType');
    });
  }

  editFinanceAccountType(id) {
    this.isEdit = true;
    this.id = id;
    var x = this.financeService.getFinanceAccountType(id);
    x.once("value").then((FinanceAccountType) => {
      this.accTypeForm.get('accTypeName').setValue(FinanceAccountType.child("accTypeName").val(), Validators.required);
      this.accTypeForm.get('accTypeLevel').setValue(FinanceAccountType.child("accTypeLevel").val(), Validators.required);
      this.accTypeForm.get('accTypeDesc').setValue(FinanceAccountType.child("accTypeDesc").val(), Validators.required);
      this.accTypeForm.get('id').setValue(id);
    });

    this.AddFinanceAccountType.show();
  }

  submitAccType() {
    this.submitted = true;
    this.doesExist = false;
    if (this.accTypeForm.valid) {
      this.checkExistsWhileAdd(this.accTypeForm.value.accTypeName, 'accTypeName', 'financeAccountType').then((data) => {
        if(data[0]!==0) {
          var res = data[1].val();
          var key = Object.keys(res);
        }
        if (data[0] == 0 || (key[0]===this.accTypeForm.value.id && data[0]==1 && this.isEdit)) {
          if (!this.isEdit) {
            this.financeService.addFinanceAccountType(this.accTypeForm.value).then(() => {
              this.submitted = false;
              this.accTypeForm.reset();
              this.AddFinanceAccountType.hide();
            });
          }
          else {
            this.financeService.updateFinanceAccountType(this.accTypeForm.value).then(() => {
              this.submitted = false;
              this.isEdit = false;
              this.accTypeForm.reset();
              this.AddFinanceAccountType.hide();
            });
          }
        }
        else {
          this.showExitsMessage(this.accTypeForm.value.accTypeName, 'Account Type');
        }
      });
    }
  }

  loadItemSearchResult(type) {
    if (type === "FinanceExpenseCat") {
      this.FinanceExpenseCat = {
        data: this.OriginalFinanceExpenseCat.slice(this.skip, this.skip + this.pageSize),
        total: this.OriginalFinanceExpenseCat.length
      };
    } else if (type === "FinanceExpenseCatType") {
      this.FinanceExpenseCatType = {
        data: this.OriginalFinanceExpenseCatType.slice(this.skip1, this.skip1 + this.pageSize),
        total: this.OriginalFinanceExpenseCatType.length
      };
    } else if (type === "FinanceAccountType") {
      this.FinanceAccountType = {
        data: this.OriginalFinanceAccountType.slice(this.skip2, this.skip2 + this.pageSize),
        total: this.OriginalFinanceAccountType.length
      };
    }

  }
  public onPageChange(event: PageChangeEvent, type): void {
    if (type === "FinanceExpenseCat") {
      this.skip = event.skip;
    } else if (type === "FinanceExpenseCatType") {
      this.skip1 = event.skip;
    } else if (type === "FinanceAccountType") {
      this.skip2 = event.skip;
    }
    this.loadItemSearchResult(type);
  }

}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/finance-management/finance-settings/finance-settings.component.ts